import { render, staticRenderFns } from "./SickLeavePolicyList.vue?vue&type=template&id=6c2f116a&scoped=true&"
import script from "./SickLeavePolicyList.vue?vue&type=script&lang=ts&"
export * from "./SickLeavePolicyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2f116a",
  null
  
)

export default component.exports